import { httpClient } from '../httpClient/httpClient';

export interface VatCode {
  id: number;
  branchId: number;
  identifier: string;
  name: string;
  displayOrder: number;
  value: number;
  archived: boolean;
}

export interface VatCodeRequest {
  name: string;
  identifier: string;
  displayOrder: number;
  value: number;
  archived: boolean;
}

export const vatCodesApi = {
  getAllVatCodes: () => httpClient.get<VatCode[]>(`vatcodes`),
  getForBranch: (branchId: number) =>
    httpClient.get<VatCode[]>(`branches/${branchId}/vatcodes`),
  create: (branchId: number, request: VatCodeRequest) =>
    httpClient.post<VatCode>(`branches/${branchId}/vatcodes`, {
      data: request,
    }),
  update: (id: number, request: VatCodeRequest) =>
    httpClient.put<VatCode>(`vatcodes/${id}`, { data: request }),
};
